const MOBILE_UA_REGEX = /Android|iPhone|iPod|iPad/i

export const isMobileDevice = (): boolean => {
  if (MOBILE_UA_REGEX.test(navigator.userAgent)) {
    return true
  }

  // iPadOS 13+ reports a desktop Safari UA, so it slips past the regex above
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
}
